import React from 'react'

const CancelledOrders = () => {
  return (
    <div>CancelledOrders</div>
  )
}

export default CancelledOrders